<template>
    <div class="tooltip tooltip--bottom">
        <div class="tooltip-message">
            <slot></slot>
        </div>
    </div>
</template>
